import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook that listens for 'store-access-denied' events dispatched by the
 * apiClient 403 interceptor. Shows a toast and redirects to the dashboard.
 *
 * Mount this once in a component that is always rendered while authenticated
 * (e.g. the main layout / sidebar).
 */
export function useStoreAccessDenied() {
    const navigate = useNavigate();
    const { toast } = useToast();

    useEffect(() => {
        const handler = (e: Event) => {
            const detail = (e as CustomEvent).detail;
            toast({
                title: 'Store access denied',
                description:
                    detail?.message ||
                    "You don't have access to this store. Contact your workspace admin.",
                variant: 'destructive',
            });
            navigate('/', { replace: true });
        };

        window.addEventListener('store-access-denied', handler);
        return () => window.removeEventListener('store-access-denied', handler);
    }, [navigate, toast]);
}
